// @flow
import React from "react";
import Wide from "../../../svg/facilities/is_wide.svg";
import "./wideIcon.scss";

const WideIcon = () => <Wide className="c-wide-icon" />;

export default WideIcon;
